import {
  collection, doc, addDoc, getDocs, updateDoc, deleteDoc,
  query, orderBy, limit,
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const AVATAR_COLORS = [
  '#8B2635', '#2563EB', '#059669', '#D97706', '#7C3AED',
  '#DB2777', '#0891B2', '#65A30D', '#0284C7', '#EA580C',
  '#6366F1', '#0D9488',
];

export const AVATAR_ICONS = [
  '🦁', '🐻', '🐼', '🦊', '🐯', '🐸', '🦋',
  '🌟', '⭐', '🎯', '🌈', '🚀', '🌸', '🏆',
  '🎸', '🎨', '🌿', '🦄', '🐬', '🎪',
];

export const AGE_RANGES = [
  { value: 'toddler',    label: 'Toddler'     },
  { value: 'preschool',  label: 'Preschool'   },
  { value: 'school_age', label: 'School Age'  },
  { value: 'teen',       label: 'Teen'        },
  { value: 'adult',      label: 'Adult'       },
];

export const SKILL_LEVELS = [
  { value: 'beginner',     label: 'Beginner'     },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced',     label: 'Advanced'     },
];

const MAX_PROFILES  = { trial: 1, full: 20 };
const SESSION_LIMIT = { trial: 5, full: 30 };

const profilesCol = (uid)       => collection(db, 'users', uid, 'sessionProfiles');
const sessionsCol = (uid, pid)  => collection(db, 'users', uid, 'sessionProfiles', pid, 'sessions');

export const createProfile = async (userId, profileData, currentCount, accountType = 'full') => {
  const max = MAX_PROFILES[accountType] ?? MAX_PROFILES.full;
  if (currentCount >= max) return { success: false, error: 'LIMIT_REACHED' };
  try {
    const ref = await addDoc(profilesCol(userId), {
      ...profileData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return { success: true, id: ref.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getProfiles = async (userId) => {
  try {
    const q = query(profilesCol(userId), orderBy('createdAt', 'asc'));
    const snap = await getDocs(q);
    return { success: true, data: snap.docs.map(d => ({ id: d.id, ...d.data() })) };
  } catch (error) {
    return { success: false, data: [], error: error.message };
  }
};

export const updateProfile = async (userId, profileId, updates) => {
  try {
    await updateDoc(doc(db, 'users', userId, 'sessionProfiles', profileId), {
      ...updates,
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const deleteProfile = async (userId, profileId) => {
  try {
    await deleteDoc(doc(db, 'users', userId, 'sessionProfiles', profileId));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const saveProfileSession = async (userId, profileId, sessionData) => {
  try {
    await addDoc(sessionsCol(userId, profileId), {
      ...sessionData,
      completedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getProfileSessions = async (userId, profileId, accountType = 'full') => {
  const lim = SESSION_LIMIT[accountType] ?? SESSION_LIMIT.full;
  try {
    const q = query(
      sessionsCol(userId, profileId),
      orderBy('completedAt', 'desc'),
      limit(lim),
    );
    const snap = await getDocs(q);
    return { success: true, data: snap.docs.map(d => ({ id: d.id, ...d.data() })) };
  } catch (error) {
    return { success: false, data: [], error: error.message };
  }
};

export const getProfileSessionLimit = (accountType) =>
  SESSION_LIMIT[accountType] ?? SESSION_LIMIT.full;

export const getProfileMax = (accountType) =>
  MAX_PROFILES[accountType] ?? MAX_PROFILES.full;
